import type { DimensionValue, StyleProp, ViewStyle } from 'react-native'
import { View } from 'react-native'
import Animated, {
  useAnimatedStyle,
  useDerivedValue,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated'

import { STATISTICS_ICON_SIZE } from '../../assets/StatisticsIcons'
import { STAT_CARD_STYLE } from '../../constants/statistics.styles'

const SKELETON_BASE_COLOR = '#E0E0E0'
const SKELETON_PLACEHOLDER_COUNT = 6

function useSkeletonAnimatedStyle() {
  const opacity = useDerivedValue(() =>
    withRepeat(
      withSequence(
        withTiming(0.7, { duration: 1000 }),
        withTiming(0.3, { duration: 1000 }),
      ),
      -1,
      true,
    ),
  )

  return useAnimatedStyle(() => ({
    opacity: opacity.value,
  }))
}

function SkeletonItem({
  width,
  height,
  borderRadius = 4,
  style,
}: {
  width: DimensionValue
  height: number
  borderRadius?: number
  style?: StyleProp<ViewStyle>
}) {
  const animatedStyle = useSkeletonAnimatedStyle()

  return (
    <Animated.View
      style={[
        {
          width,
          height,
          backgroundColor: SKELETON_BASE_COLOR,
          borderRadius,
        },
        animatedStyle,
        style,
      ]}
    />
  )
}

function StatisticsMetricCardSkeleton() {
  return (
    <View
      style={STAT_CARD_STYLE}
      accessibilityRole="progressbar"
      accessible
      accessibilityLabel="Loading"
    >
      <SkeletonItem
        width={STATISTICS_ICON_SIZE}
        height={STATISTICS_ICON_SIZE}
        borderRadius={6}
        style={{ marginBottom: 7, marginLeft: -2 }}
      />
      <SkeletonItem width="60%" height={12} style={{ marginBottom: 8 }} />
      <SkeletonItem width="45%" height={20} style={{ marginBottom: 8 }} />
      <SkeletonItem width="50%" height={12} />
    </View>
  )
}

export function StatisticsCardsSkeleton() {
  return (
    <View className="flex-row flex-wrap justify-between">
      {Array.from({ length: SKELETON_PLACEHOLDER_COUNT }).map((_, index) => (
        <StatisticsMetricCardSkeleton key={index} />
      ))}
    </View>
  )
}
